import React, { Fragment, useRef, useState } from "react";
import { Text } from "./Text";
import Upload from "../Icons/upload-image.png";
import { Control, Controller } from "react-hook-form";
import { Div } from "./Div";
import { PuffLoader } from "react-spinners";
import { colors } from "../../StyleSheet";

export type FileInputProps = {
  control: Control<any>;
  name: string;
  title: string;
  onFileChange?: (file?: File) => void;
  loading?: boolean;
};
export const FileInput: React.FC<FileInputProps> = (props) => {
  const { name, control, onFileChange, loading } = props;
  const [, setFile] = useState<File | undefined>();
  const hiddenInputRef = useRef<any>();
  const onClick = () => {
    hiddenInputRef?.current?.click();
  };

  return (
    <Controller
      control={control}
      render={({ field: { onChange } }) => (
        <button
          id="file-input"
          onDragOver={(e) => {
            e.preventDefault();
            e.stopPropagation();
          }}
          onDrop={(e) => {
            e.preventDefault();
            e.stopPropagation();
            setFile(e.dataTransfer.files[0]);
            onChange(e.dataTransfer.files[0]);
            onFileChange && onFileChange(e.dataTransfer.files[0]);
          }}
          className="flex  justify-center h-[300px] w-full rounded-[8px] text-sm"
          onClick={onClick}
        >
          <Div
            bg="secondary"
            className="w-full px-[11px] rounded-[8px] border-dashed border-[2px] h-[300px] border-[#CCCCCC] flex justify-center items-center group "
          >
            <div className="w-full flex flex-col items-center justify-center py-[32px]">
              {loading ? (
                <PuffLoader size={32} color={colors.primary} />
              ) : (
                <Fragment>
                  <img
                    src={Upload}
                    alt="upload-icon"
                    draggable={false}
                    className="w-[200px] group-hover:animate-customBounce"
                  />
                  <Text
                    elementType="p"
                    className="text-lg mt-1"
                    color="textNotActive"
                    fontWeight={500}
                  >
                    submitProcess.personalDetails.uploadFileSection.dragOrClick
                  </Text>
                  <Text
                    elementType="p"
                    className="text-xs mt-1"
                    color="textNotActive"
                    fontWeight={500}
                  >
                    submitProcess.personalDetails.uploadFileSection.maxFileSize
                  </Text>
                </Fragment>
              )}
            </div>
            <input
              type="file"
              className="hidden"
              accept="application/pdf, image/jpeg, image/jpg, image/png"
              ref={hiddenInputRef}
              onChange={(e) => {
                setFile(e?.target?.files?.[0]);
                onChange(e?.target?.files?.[0]);
                onFileChange && onFileChange(e?.target?.files?.[0]);
              }}
            />
          </Div>
        </button>
      )}
      name={name}
    />
  );
};
